import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
/**
 * Generated class for the DishTutorialSlidePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'tutorial-box',
  templateUrl: 'tutorial-box.html',
})
export class TutorialBox {

  //pas de cada tour
  @Input() tour: any;
  @Input() step: any;
  @Input() href_active: any;
  @Input() href_link: any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals) {
  }

}



// WEBPACK FOOTER //
// ./src/pages/help/tutorial-box/tutorial-box.ts